import { ProgressSpinner } from "primereact/progressspinner";
import React from "react";

export const FullScreenLoader: React.FC<{ showText?: boolean }> = ({ showText = true }) => {
  return (
    <div className="flex items-center justify-center h-full w-full bg-transparent" role="status">
      <div className="flex flex-col items-center">
        <ProgressSpinner animationDuration="1s" />
        {showText ? (
          <span className="mt-4 text-lg font-semibold text-gray-700">Loading...</span>
        ) : (
          <span className="sr-only">Loading...</span>
        )}
      </div>
    </div>
  );
};
